export const boardCalenderTour = {
  key: "boardCalender",
  version: 1,
  getSteps: (t) => [
    {
      target: '[data-tour="board-calender-viewswitch"]',
      content: t("Tour_BoardCalender_ViewSwitch"),
      placement: "bottom",
      disableBeacon: true,
    },
    {
      target: "body",
      content: t("Tour_BoardCalender_DragDrop"),
      placement: "center",
      disableBeacon: true,
    },
    {
      target: '[data-tour="board-calender-filters"]',
      content: t("Tour_BoardCalender_Filters"),
      placement: "bottom",
      disableBeacon: true,
    },
    {
      target: "body",
      content: t("Tour_BoardCalender_NewEvent"),
      placement: "center",
    },
  ],
};
